import React, { useEffect, useRef, useState } from "react";

const toInputValue = (iso, includeTime) => {
  if (!iso) return "";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "";
  const pad = (n) => String(n).padStart(2, "0");
  const date = `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
  if (!includeTime) return date;
  return `${date}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
};

const formatDisplay = (iso, includeTime) => {
  if (!iso) return null;
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return null;
  const date = d.toLocaleDateString(undefined, { month: "short", day: "numeric", year: "numeric" });
  if (!includeTime) return date;
  return `${date} ${d.toLocaleTimeString(undefined, { hour: "2-digit", minute: "2-digit" })}`;
};

export default function DateCell({ value, column, readOnly, onCommit }) {
  const [editing, setEditing] = useState(false);
  const includeTime = !!column?.settings?.include_time;
  const [draft, setDraft] = useState(toInputValue(value, includeTime));
  const ref = useRef(null);

  useEffect(() => {
    setDraft(toInputValue(value, includeTime));
  }, [value, includeTime]);

  useEffect(() => {
    if (editing) ref.current?.focus();
  }, [editing]);

  const commit = () => {
    setEditing(false);
    if (!draft) {
      if (value) onCommit(null);
      return;
    }
    const iso = new Date(draft).toISOString();
    if (iso !== value) onCommit(iso);
  };

  if (editing && !readOnly) {
    return (
      <input
        ref={ref}
        type={includeTime ? "datetime-local" : "date"}
        className="cell-input"
        value={draft || ""}
        onChange={(e) => setDraft(e.target.value)}
        onBlur={commit}
        onKeyDown={(e) => {
          if (e.key === "Enter") commit();
          if (e.key === "Escape") setEditing(false);
        }}
      />
    );
  }

  const display = formatDisplay(value, includeTime);
  return (
    <div
      className={`cell-display date ${readOnly ? "read-only" : ""}`}
      onClick={() => !readOnly && setEditing(true)}
    >
      {display || <span className="placeholder">—</span>}
    </div>
  );
}
